/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react"
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import { createContranctsSign, getContracts } from "../../apis/contract";
import Editor from "../../components/Editor";
import Button from "../../components/Button";
import { decode } from "jsonwebtoken";
import { getCompanyToken } from "../../apis/auth";
import systemAlert from "../../utils/systemAlert";
import CanvasDraw from "react-canvas-draw";
import { SIGN_TEXT } from "../../constants/CONTRACT";

const ContractWebView = () => {
  const history = useHistory();
  const canvasDraw = useRef(null)
  const [html, setHtml] = useState(null)
  const [defaultValue, setDefaultValue] = useState(null)
  const [isSigned, setIsSigned] = useState(false)
  const [contract, setContract] = useState(null)
  const [mode, setMode] = useState('detail')
  const [brushRadius, setBrushRadius] = useState(3)
  const [contractId, setContractId] = useState(null)
  const token = getCompanyToken()
  const me = decode(token)

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    if (query && query.id) {
      getContract(query.id)
      setContractId(query.id)
    }
  }, [history.location])

  const getContract = (contractIdx) => {
    getContracts(Number(contractIdx))
      .then((res) => {
        const { html } = res.data
        setContract(res.data)
        setIsSigned(res.data.isSigned)
        setDefaultValue(html)
      })
      .catch(() => { })
  }

  const handleOnChangeEditor = (content) => {
    setHtml(content)
  }

  const handleSign = () => {
    setMode('modify')
  }

  const handleApply = () => {
    const canvas = document.querySelector(".canvas-draw canvas:nth-child(2)");
    const signImage = canvas.toDataURL("image/png");
    systemAlert('해당 계약서에 서명을 하시겠습니까?', {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '확인',
          onClick: () => {
            const img = new Image()
            img.src = signImage
            img.alt = '직원서명'
            img.width = 80
            img.height = 80
            img.style.position = 'absolute'
            img.style.transform = 'translate(0%, -40%)'

            const sign = img.outerHTML
            const transHtml = html.replace(SIGN_TEXT, `${sign}`)
            createContranctsSign(contractId, { html: transHtml }).then(() => {
              window.location.reload()
            })
          }
        }
      ]
    })
  }

  const handleClear = () => {
    canvasDraw.current.clear()
  }

  const handleUndo = () => {
    canvasDraw.current.undo()
  }

  const handleChangeBrush = (e) => {
    const { value } = e.target
    setBrushRadius(parseInt(value, 10))
  }

  const cancel = () => {
    setMode('detail')
  }

  return (
    <div className="contract-webview-container">
      {mode === 'detail' ? (
        <>
          <Editor
            value={html}
            defaultValue={defaultValue}
            onChange={handleOnChangeEditor}
            readOnly
          />
          <div className="float-right contact-content-button-wrap">
            {!isSigned && me && me.employeeIdx === (contract && contract.targetEmployeeIdx) && (
              <Button className="mr-20 mb-20" onClick={handleSign}>서명하기</Button>
            )}
          </div>
        </>
      ) : (
        <div className="sign-write">
          <div className="canvas-wrap">
            <div className="cavas-controller-container">
              <Button
                size="sm"
                label="전체취소"
                color="text"
                action={handleClear}
              />
              <Button
                size="sm"
                label="실행취소"
                color="text"
                action={handleUndo}
              />
              <div className="brush-wrap">
                <span className="title">펜 크기</span>
                <input className="brush-input" type="number" min={1} max={10} value={brushRadius} onChange={handleChangeBrush} />
              </div>
            </div>
            <CanvasDraw
              ref={canvasDraw}
              className="canvas-draw"
              style={{
                boxShadow:
                  "0 13px 27px -5px rgba(50, 50, 93, 0.25),    0 8px 16px -8px rgba(0, 0, 0, 0.3)"
              }}
              brushRadius={brushRadius}
            />
          </div>
          <div className="submit-button-wrap float-right margin-top-32">
            <Button
              className="button"
              size="lg"
              label="취소"
              color="text"
              action={cancel}
            />
            <Button
              className="button"
              size="lg"
              label="서명"
              action={handleApply}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default ContractWebView